import {Injectable} from '@angular/core';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import {map} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {LoadCurrentSubscriptionAction} from '../actions/current-subscription';
import {ChangeSubscriptionAction, userContextActionTypes} from '../actions/user-context';

@Injectable()
export class UserContextSubscriptionEffect {

  changeSubscription$ = createEffect(() => { return this.actions$.pipe(ofType(userContextActionTypes.CHANGE_SUBSCRIPTION),
    debug('Change subscription action received'),
    map((action: ChangeSubscriptionAction) =>
      new LoadCurrentSubscriptionAction(action.payload)
    )
  )});

  constructor(private actions$: Actions) {}
}
